export default [
  {
    path: '/hongKongImprint',
    name: 'HongKongImprint',
    component: () => import('../pages/index.vue'),
    redirect: '/hongKongImprint/launch',
    meta: {
      title: '环球印记',
      layout: {
        navBar: { showNavBar: false, showLeftArrow: false },
        tabbar: { showTabbar: false }
      }
    },
    children: [
      {
        path: 'launch',
        name: 'HongKongImprintLaunch',
        component: () => import('../pages/LaunchPage.vue'),
        meta: { title: '环球印记' }
      },
      {
        path: 'map',
        name: 'HongKongImprintMap',
        component: () => import('../pages/MapPage.vue'),
        meta: { title: '环球印记 - 地图' }
      },
      {
        path: 'destination',
        name: 'HongKongImprintDestination',
        component: () => import('../pages/DestinationPage.vue'),
        meta: { title: '环球印记 - 目的地' }
      },
      {
        path: 'product',
        name: 'HongKongImprintProduct',
        component: () => import('../pages/ProductPage.vue'),
        meta: { title: '环球印记 - 产品' }
      },
      {
        path: 'badge',
        name: 'HongKongImprintBadge',
        component: () => import('../pages/BadgePage.vue'),
        meta: { title: '环球印记 - 勋章' }
      },
      {
        path: 'coupon',
        name: 'HongKongImprintCoupon',
        component: () => import('../pages/CouponPage.vue'),
        meta: { title: '环球印记 - 权益' }
      },
      {
        path: 'lottery',
        name: 'HongKongImprintLottery',
        component: () => import('../pages/LotteryPage.vue'),
        meta: { title: '环球印记 - 抽奖' }
      },
      {
        path: 'result',
        name: 'HongKongImprintResult',
        component: () => import('../pages/ResultPage.vue'),
        meta: { title: '环球印记 - 结果' }
      },
    ]
  }
]
